<template>
    <div class="antd-pro-components-top-nav-header-index-head">
        <div class="antd-pro-components-top-nav-header-index-main ">
            <div class="antd-pro-components-top-nav-header-index-left">
                <z-logo></z-logo>
                <z-menu></z-menu>
                <div>
                  <a-select size="small" :default-value="lang" style="width: 100px" @change="changeLocale">
                    <template v-for="(item) in langs">
                      <a-select-option :key="item.value" :value="item.value">
                        {{item.name}}
                      </a-select-option>
                    </template>
                  </a-select>
                </div>
                <a-dropdown>
                    <div class="ant-dropdown-link" style="color:white;cursor: pointer;margin: 0 10px">
                        <a-icon style="font-size: 1.1rem" type="read" />
                        <span style="margin-left: 5px;color: #eee">{{$t('global.helpDocs')}}</span>
                    </div>
                    <a-menu slot="overlay">
                        <!-- <a-menu-item>
                            <a  @click="toDownload">{{$t('global.download')}}</a>
                        </a-menu-item> -->
                        <!-- <a-menu-item>
                            <a target="black" href="http://www.zxsmart.cn:8091/device-help.html">{{$t('global.deviceDocs')}}</a>
                        </a-menu-item> -->
                        <a-menu-item>
                            <a target="black" href="https://zxsmart.cn/source/help.html">{{$t('global.systemDocs')}}</a>
                        </a-menu-item>
                        <!-- <a-menu-item>
                            <a target="black" href="http://www.zxsmart.cn:8091/android-user-manual.html">{{$t('global.androidAPPDocs')}}</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a target="black" href="http://www.zxsmart.cn:8091/mini-program-manual.html">{{$t('global.wxminAppDocs')}}</a>
                        </a-menu-item> -->
                    </a-menu>
                </a-dropdown>

                <!-- <a-dropdown v-show="lang == 'en'">
                    <div class="ant-dropdown-link" style="color:white;cursor: pointer;">
                        English(US)<a-icon type="down" />
                    </div>
                    <a-menu slot="overlay">
                        <a-menu-item>
                            <span  @click="changeLocale('zh-cn')">中文</span>
                        </a-menu-item>
                        <a-menu-item>
                            <span  @click="changeLocale('ru')">俄语</span>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
                <a-dropdown v-show="lang != 'en'">
                    <div class="ant-dropdown-link" style="color:white;cursor: pointer;">
                        中文<a-icon type="down" />
                    </div>
                    <a-menu slot="overlay">
                        <a-menu-item>
                            <span  @click="changeLocale('en')">English(US)</span>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown> -->
            </div>

            <div class="antd-pro-components-global-header-index-right">
                <z-alarm></z-alarm>
                <z-user></z-user>
            </div>
        </div>
        <Mobile />
        <div class="broadcast">
          <i @click="showBroadcast" class="icon">
            <zx-icon type="icon-tongzhi3"></zx-icon>
          </i>
        </div>
        <Broadcast ref="broadcast" />
        <!-- <Beian /> -->
        <a-modal v-model="show" width="50%">
          <div class="download">
            <div class="item">
              <img class="qr" src="../../assets/images/apk.png" alt="">
              <div class="txt">{{$t('global.scanQRToDownload')}}</div>
            </div>
            <div class="item">
              <img class="qr" src="../../assets/images/we-min-app.jpg" alt="">
              <div class="txt">{{$t('global.scanQRToWXapp')}}</div>
            </div>
          </div>
        </a-modal>
    </div>
</template>

<script>
    import ZMenu from '@/components/common/Menu.vue'
    import ZLogo from '@/components/common/Logo.vue'
    import ZAlarm from "@/components/common/Alarm.vue"
    import ZUser from "@/components/common/User.vue"
    import Mobile from './Mobile'
    import {mapActions, mapState} from 'vuex'
import bus from '../../bus/bus';
    export default {
        name: 'ZHeader',
        data(){
            return {
                // locale: localStorage.getItem('lang') || 'zh-cn'
              show: false,
              // langs: [
              //   {value: 'zh-cn', name: '中文'},
              //   {value: 'en', name: 'English'},
              //   {value: 'ru', name: '俄语'},
              // ]
            }
        },
        components:{
            ZAlarm,
            ZMenu,
            ZLogo,
            ZUser,
            Mobile,
            Broadcast: () => import('../Broadcast/Broadcast'),
            // Beian: () => import('./Beian')
        },
        computed: {
          ...mapState(['lang']),
          langs () {
            return [
              {value: 'zh-cn', name: this.$t('global.chinese')},
              {value: 'en', name: this.$t('global.english')},
              {value: 'ru', name: this.$t('global.russian')},
            ]
          },
        },
        methods:{
          ...mapActions(['setLang']),
          showBroadcast () {
            // console.log('click')
            this.$refs['broadcast'].visable = !this.$refs['broadcast'].visable
          },
          changeLocale(locale){
            // this.locale = locale
            this.setLang(locale)
            // localStorage.setItem('locale', locale)
            this.$i18n.locale = locale
            // console.log(locale)
            this.$moment.locale(locale)
            // console.log(this.$moment.locale())
            bus.$emit('langChanged', locale)
            window.location.reload()
          },
          toDownload () {
            // 打开modal
            this.show = true
          }
        }
    }
</script>
<style lang="less" scoped>
a {
  color: #e0e0e0 !important;
}
.broadcast {
  position: fixed;
  bottom: 335px;
  right: 20px;
  .icon {
    font-size: 3.2rem;
    padding: 5px;
    cursor: pointer;
    // border-radius: 50%;
    // border: 1px solid #666;
  }
}
.download {
  // display: grid;
  // grid-template-columns: 1fr 1fr;
  // grid-gap: 20px;
  display: flex;

  // align-content: center;
  justify-content: center;
  align-items: center;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 30px auto;
    .qr {
      width: 150px;
    }
    .txt {
      margin-top: 20px;
    }
  }
}

</style>
